import { mapGetters } from 'vuex';
import HomeWidgetConsts from 'client/Home/constants/HomeWidgetConsts';

const {
  widgetTypes,
} = HomeWidgetConsts;

const {
  blog,
  community,
  guidedSetup,
  msp,
  tutorialResources,
} = widgetTypes;

const onboardingModule = 'OnboardingModule';

export default {

  computed: {
    ...mapGetters(onboardingModule, {
      getResourceFromDisplayPreferences: 'getResourceFromDisplayPreferences',
      getResourceTypeFilterFromDisplayPreferences: 'getResourceTypeFilterFromDisplayPreferences',
    }),

    blogPreferences() {
      return this.getResourceFromDisplayPreferences(blog);
    },

    communityPreferences() {
      return this.getResourceFromDisplayPreferences(community);
    },

    guidedSetupPreferences() {
      return this.getResourceFromDisplayPreferences(guidedSetup);
    },

    mspPreferences() {
      return this.getResourceFromDisplayPreferences(msp);
    },

    resourceTypeFilter() {
      return this.getResourceTypeFilterFromDisplayPreferences;
    },

    tutorialPreferences() {
      return this.getResourceFromDisplayPreferences(tutorialResources);
    },

  },
};
